import React, {FC, useEffect, useState} from "react"
import PropTypes from "prop-types"

import {RedemptionReportDuration} from "@irati/types/generated/ops"
import {useUserSavings} from "@irati/adminReporting/hooks"
import MySavingsCard from "@irati-web/my-savings/src/components/SavingsTracker/Widgets/MySavings"
import platformTracking from "@irati-tracking/platform/platform"
import {RouterLink} from "@irati/ui/src/Link"

import devToggles from "@irati/dev-toggles"
import DesktopMenu from "../DesktopMenu"
import MySavingsHeaderWidget from "./MySavingsHeaderWidget"

const MySavings: FC = (_, {apps}) => {
  const {data} = useUserSavings({duration: RedemptionReportDuration.CustomDate})
  const savings = data?.savings?.fixed

  const [isMenuDisplayed, setIsMenuDisplayed] = useState(false)

  useEffect(() => {
    if (isMenuDisplayed) {
      platformTracking.click("savings", {source: "header"})
    }
  }, [isMenuDisplayed])

  const toggle = () => {
    setIsMenuDisplayed((current) => !current)
  }

  if (!data) return null

  return devToggles.showMySavingsV2() ? (
    <RouterLink to="/" app={apps.SAVINGS} plain onClick={() => platformTracking.click("savings", {source: "header"})}>
      <MySavingsHeaderWidget savings={savings} />
    </RouterLink>
  ) : (
    <DesktopMenu
      id="platform_header_savings_button"
      show={isMenuDisplayed}
      tooltip="My Savings"
      onClick={toggle}
      onOutsideClick={toggle}
      content={<MySavingsCard showInHeader />}>
      <MySavingsHeaderWidget savings={savings} />
    </DesktopMenu>
  )
}

MySavings.contextTypes = {
  apps: PropTypes.object.isRequired
}

export default MySavings
